const CRM_CACHE_PREFIX = 'crm';
const DEFAULT_TTL = 60 * 1000;

const isBrowser = () => typeof window !== 'undefined' && window.sessionStorage;
const currentAccountId = () => {
  if (typeof window === 'undefined') return 'global';

  const match = window.location.pathname.match(/\/app\/accounts\/(\d+)/);
  return match?.[1] || 'global';
};

const normalize = value => {
  if (Array.isArray(value)) return value.map(normalize);
  if (!value || typeof value !== 'object') return value;

  return Object.keys(value)
    .sort()
    .reduce((acc, key) => {
      if (key === 'force' || value[key] === undefined) return acc;
      acc[key] = normalize(value[key]);
      return acc;
    }, {});
};

export const apiParamsWithoutCacheControl = (params = {}) =>
  normalize(params) || {};

export const shouldBypassCrmCache = (params = {}) => Boolean(params.force);

const buildKey = (scope, params = {}) =>
  `${CRM_CACHE_PREFIX}:${currentAccountId()}:${scope}:${JSON.stringify(normalize(params))}`;

export const readCrmCache = (scope, params, ttl = DEFAULT_TTL) => {
  if (!isBrowser()) return null;

  try {
    const raw = window.sessionStorage.getItem(buildKey(scope, params || {}));
    if (!raw) return null;

    const cached = JSON.parse(raw);
    if (Date.now() - cached.cachedAt > ttl) return null;

    return cached.data;
  } catch {
    return null;
  }
};

export const writeCrmCache = (scope, params, data) => {
  if (!isBrowser()) return;

  try {
    window.sessionStorage.setItem(
      buildKey(scope, params || {}),
      JSON.stringify({ cachedAt: Date.now(), data })
    );
  } catch {
    // Cache is best-effort.
  }
};
